<div class="row">
  <div class="col-md-6 col-12 mt-2 pr-3" *ngFor="let card of cardListConfig">
    <a [routerLink]="[card.route]" class="title-card">
      <div class="card-space d-flex justify-content-center">
        <div class="card card-bg card-big">
          <div class="card-body card-body-custom">
            <div class="row my-2">
              <div class="col-8 d-flex align-items-center">
                <h3 class="title-card">
                  {{ card.title | translate }}
                </h3>
                <p *ngIf="card.description" class="descr-card mt-3">
                  {{ card.description | translate }}
                </p>
              </div>
              <div class="col-4" *ngIf="card.icon">
                <div
                  *ngIf="card.icon === typeIcon.FOLDER"
                  class="top-icon m-0 d-flex justify-content-end"
                >
                  <div>
                    <img
                      [alt]="'FOLDER_ALT_TEXT' | translate"
                      src="assets/folder.svg"
                    />
                  </div>
                </div>
                <div
                  *ngIf="card.icon === typeIcon.CHECK"
                  class="top-icon m-0 d-flex justify-content-end"
                >
                  <svg
                    width="44"
                    height="44"
                    viewBox="0 0 44 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="44" height="44" rx="22" fill="#0066CC" />
                    <path
                      d="M19.6 26.9L14 21.4L14.8 20.7L19.6 25.5L28.1 17.1L28.8 17.8L19.6 26.9Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <div
                  *ngIf="card.icon === typeIcon.CALENDAR"
                  class="top-icon m-0 d-flex justify-content-end"
                >
                  <svg
                    class="bootstrap-calendar"
                    aria-hidden="true"
                  >
                    <use href="assets/bootstrap-italia.svg#it-calendar"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</div>
